// src/components/Footer.tsx
import { useEffect, useState } from "react";
import { FOOTER_STATS, SOCIAL_LINKS } from "../data/content.js";

export default function Footer() {
  const [tps, setTps] = useState("1,284");

  useEffect(() => {
    const id = setInterval(() => {
      setTps((1200 + Math.floor(Math.random() * 200)).toLocaleString("en"));
    }, 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer style={{
      position: "relative", zIndex: 1,
      borderTop: "1px solid rgba(124,58,237,.12)",
      background: "rgba(7,7,15,.9)",
      padding: "16px 32px",
      display: "flex", alignItems: "center", gap: 0, flexWrap: "wrap",
    }}>
      {/* Token */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, paddingRight: 24 }}>
        <div style={{
          width: 34, height: 34, borderRadius: "50%",
          background: "linear-gradient(135deg,#7c3aed,#4f46e5)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontFamily: "var(--display)", fontSize: 14, fontWeight: 900, color: "#fff",
          boxShadow: "0 0 20px rgba(124,58,237,.4)",
        }}>M</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text)" }}>MEE TOKEN</div>
          <div style={{ fontSize: 10, color: "var(--muted)", fontFamily: "var(--mono)" }}>$MEE</div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display: "flex", flex: 1, flexWrap: "wrap" }}>
        {FOOTER_STATS.map((s, i) => (
          <div key={s.label} style={{
            flex: 1, minWidth: 90, padding: "0 20px",
            borderLeft: "1px solid rgba(124,58,237,.1)",
          }}>
            <div style={{ fontSize: 9, fontWeight: 700, color: "var(--muted)", letterSpacing: ".1em", textTransform: "uppercase" }}>{s.label}</div>
            <div style={{ fontSize: 13, fontWeight: 700, fontFamily: "var(--mono)", marginTop: 2, color: s.green ? "#34d399" : s.muted ? "var(--muted)" : "var(--text)" }}>
              {s.liveKey === "tps" ? tps : s.value}
            </div>
          </div>
        ))}
      </div>

      {/* Social */}
      <div style={{ display: "flex", gap: 8, marginLeft: 24 }}>
        {SOCIAL_LINKS.map(s => (
          <a key={s.label} href={s.href} title={s.label} target="_blank" rel="noreferrer" style={{
            width: 30, height: 30, borderRadius: 6,
            background: "var(--bg3)", border: "1px solid rgba(124,58,237,.15)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 13, color: "var(--muted)", textDecoration: "none",
            transition: "all .15s",
          }}>{s.icon}</a>
        ))}
      </div>
    </footer>
  );
}
